<template>
  <v-snackbar
    v-model="show"
    :color="type"
    :timeout="timeout"
    :vertical="$vuetify.breakpoint.mdAndDown"
    :right="true"
    :top="true"
    style="z-index: 10000"
    data-testid="elem_u_000505"
  >
    {{ message }}
    <v-btn
      data-testid="elem_u_000506"
      dark
      text
      @click="show = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      timeout: 5000,
      type: 'success',
      message: '',
    };
  },

  methods: {
    close() {
      this.show = false;
    },
  },

  created() {
    this.$store.watch(
      (state) => state.alert.message,
      () => {
        const message = this.$store.state.alert.message;

        if (message) {
          this.show = true;
          this.message = message;
          this.type = this.$store.state.alert.type;
          this.$alert.clear();
        }
      },
    );
  },
};
</script>

<style lang="scss" scoped>
.notification-dialog {
  background: var(--color-grey-280);
  position: relative;
  padding: 15px 15px 50px;
  overflow: hidden;
  @include md-down {
    padding: 15px 15px 30px;
  }

  .btn-close-container {
    display: flex;
    width: 100%;
    height: fit-content;
  }

  .btn-close {
    height: 24px;
    width: 24px;
    margin-left: auto;
    display: flex;
  }

  .notification-dialog__content {
    padding: 10px 35px 0;
    color: var(--color-grey-900);

    @include md-down {
      padding: 10px 5px 0;
    }
  }

  .notification-dialog__title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
  }

  .notification-dialog__message {
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 30px;
  }

  .notification-dialog__actions {
    display: flex;
    width: 100%;
    height: fit-content;
    justify-content: center;
  }
}
</style>
